export var createDecodeWebMChunk = function (readElementContent, readElementType) {
    return function (dataView, elementType, channelCount) {
        var contents = [];
        var currentElementType = elementType;
        var offset = 0;
        while (offset < dataView.byteLength) {
            if (currentElementType === null) {
                var lengthAndType = readElementType(dataView, offset);
                if (lengthAndType === null) {
                    break;
                }
                var length = lengthAndType.length, type = lengthAndType.type;
                currentElementType = type;
                offset += length;
            }
            else {
                var contentAndLength = readElementContent(dataView, offset, currentElementType, channelCount);
                if (contentAndLength === null) {
                    break;
                }
                var content = contentAndLength.content, length = contentAndLength.length;
                currentElementType = null;
                offset += length;
                if (content !== null) {
                    contents.push(content);
                }
            }
        }
        return { contents: contents, currentElementType: currentElementType, offset: offset };
    };
};
//# sourceMappingURL=decode-web-m-chunk.js.map
